import React, {useContext, useEffect} from 'react'
import Layout from '../../../components/layout/layout'
import mlroleHealthImage from '../../../images/articles/mlrole-health.jpg'
import moralrisk2 from '../../../images/articles/moralrisk2.jpg'
import aidepressivemain from '../../../images/articles/aidepressivemain.jpg'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import './articlesMain.scss'
import aiinArchitect1 from '../../../images/articles/aiinArchitect1.jpg'
import mlFails from '../../../images/articles/mlFails.jpg'
import ecommerceImage from '../../../images/articles/ecommerce-photo.jpg'
import digitalHealthImage from '../../../images/machine-learning-healthcare.jpg'
import chatbotsImage from '../../../images/articles/chatbots-photo.jpg'
import roadmapImage from '../../../images/articles/roadmap-photo.jpg'
import computerVisionImage from '../../../images/articles/computervision-photo.jpg'
import genAiImage from '../../../images/articles/genai-photo.jpg'
import dataPrivacyImage from '../../../images/articles/dataprivacy-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import Seo, { breadcrumbJsonLd } from '../../../components/Seo/Seo'
import useEntryMotion from '../../../components/motion/useEntryMotion'
import PageBanner from '../../../components/PageBanner/PageBanner'
import articles from '../../../data/articles'
import { articleCovers, articleMeta, localizeArticle } from '../articlePage/articleShared'

// Cards are real <a href> links: as click handlers on a <div> they gave
// crawlers no path from this page to any article.
const MotionLink = motion.create(Link)

const ArticlesMain = () => {
  const animateIn = useEntryMotion();
  const { translations, selectedLanguage } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const newArticles = articles.map((source) => {
    const article = localizeArticle(source, translations)
    const meta = articleMeta(source, article, selectedLanguage, translations)
    return { img: articleCovers[source.cover], title: article.title, link: `/articles/${source.slug}`, date: meta.date, read: meta.read }
  })

  const blogBox = [
    ...newArticles,
    { img: chatbotsImage, title: translations.BlogAiChatbots, link: '/articles/aiChatbots', date: translations.BlogAiChatbots11, read: translations.BlogAiChatbots13 },
    { img: roadmapImage, title: translations.BlogMlRoadmap, link: '/articles/mlRoadmap', date: translations.BlogMlRoadmap11, read: translations.BlogMlRoadmap13 },
    { img: computerVisionImage, title: translations.BlogComputerVision, link: '/articles/computerVision', date: translations.BlogComputerVision11, read: translations.BlogComputerVision13 },
    { img: digitalHealthImage, title: translations.BlogDigitalHealth, link: '/articles/digitalHealth', date: translations.BlogDigitalHealth11, read: translations.BlogDigitalHealth13 },
    { img: genAiImage, title: translations.BlogGenAi, link: '/articles/genAi', date: translations.BlogGenAi11, read: translations.BlogGenAi13 },
    { img: dataPrivacyImage, title: translations.BlogDataPrivacy, link: '/articles/dataPrivacy', date: translations.BlogDataPrivacy11, read: translations.BlogDataPrivacy13 },
    { img: ecommerceImage, title: translations.BlogMlEcommerce, link: '/articles/mlEcommerce', date: translations.BlogMlEcommerce11, read: translations.BlogMlEcommerce13 },
    { img: mlroleHealthImage, title: translations.BlogmlroleHealth, link: '/articles/mlrolehealth', date: translations.BlogmlroleHealth12, read: translations.BlogmlroleHealth14 },
    { img: aiinArchitect1, title: translations.BlogaiinArchitect, link: '/articles/aiInArchitect', date: translations.BlogaiinArchitect20, read: translations.BlogaiinArchitect22 },
    { img: moralrisk2, title: translations.Blogmoralrisk, link: '/articles/moralRiskHealth', date: translations.Blogmoralrisk13, read: translations.Blogmoralrisk15 },
    { img: aidepressivemain, title: translations.Blogaidepressivemain, link: '/articles/aiDepressive', date: translations.Blogaidepressivemain19, read: translations.Blogaidepressivemain21 },
    { img: mlFails, title: translations.BlogmlFails, link: '/articles/mlOutRails', date: translations.BlogmlFails16, read: translations.BlogmlFails18 },
  ]

  const [featured, ...rest] = blogBox;

  return (
    <Layout>
      <Seo
        title='Articles & Insights on Machine Learning and AI'
        description='Expert articles from the MLMind team on machine learning in healthcare, architecture, e-commerce, chatbots, and how to bring AI into your business.'
        jsonLd={breadcrumbJsonLd([
          { name: 'Home', path: '/' },
          { name: 'Articles', path: '/articles' },
        ])}
      />

      <div className='articles-container articles-page'>
        <div className='articles-container-content'>
          <motion.p
            className='main-articles-blog-primary-title'
            initial={animateIn ? { opacity: 0, y: 50 } : false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            {translations.BlogPerspectives}
          </motion.p>
          <motion.h1
            className='main-articles-blog-secondary-title'
            initial={animateIn ? { opacity: 0, y: 30 } : false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          >
            {translations.BlogExpertInsights}
          </motion.h1>


          <MotionLink
            className='featured-article'
            to={featured.link}
            initial={animateIn ? { opacity: 0, y: 50 } : false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className='featured-article-img-box'>
              <img src={featured.img} alt={featured.title} className='featured-article-img' />
            </div>
            <div className='featured-article-info'>
              <p className='article-card-meta'>{featured.date} • {featured.read}</p>
              <h2 className='featured-article-title'>{featured.title}</h2>
              <span className='featured-article-readmore'>
                {translations.home3} <span className='featured-article-arrow'>→</span>
              </span>
            </div>
          </MotionLink>

          <div className='articles-grid'>
            {rest.map((article, index) => (
              <MotionLink
                key={article.link}
                className='article-card'
                to={article.link}
                initial={animateIn ? { opacity: 0, y: 40 } : false}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              >
                <div className='article-card-img-box'>
                  <img src={article.img} alt={article.title} className='article-card-img' />
                  <span className='article-card-num'>{String(index + 1).padStart(2, '0')}</span>
                </div>
                <p className='article-card-meta'>{article.date} • {article.read}</p>
                <p className='article-card-title'>{article.title}</p>
              </MotionLink>

            ))}
          </div>
        </div>

      </div>
      <PageBanner
        eyebrow={translations.bannerArticlesEyebrow}
        title={translations.bannerArticlesTitle}
        highlight={translations.bannerArticlesHighlight}
        text={translations.bannerArticlesText}
        cta={translations.bannerArticlesCta}
        to='/services'
        shape='orb'
        colors={['#312e81', '#e7ff02', '#e879f9']}
      />
    </Layout>
  )
}

export default ArticlesMain
